<template>
  <div class="container">
    <BusComponent busId="автобус-1" busType="2doors-54seats" :busRows="5" :travelers="allPeople" @seatTaken="seatTaken" @seatEmptied="seatEmptied" @placeClicked="placeClicked" />
    <div class="vertical-list">
      <span class="travelers-list">{{ $t(`traveller.travelerswithoutplace`) }}:</span>
      <travelers dropEffect="move" class="travelers" :travelers="allPeople"/>
    </div>
  </div>
</template>

<script>
import BusComponent from './BusComponent.vue'
import Travelers from './Travelers.vue'

import { tripApi } from "../../services/api/tripApi";

import { Tabs, Tab } from 'vue-simple-tabs'

export default {
  name: 'PlacePicker',
  props: {
    tripId: {
      type: Number,
      required: true
    },
    participantId: {
      type: Object|Number,
      required: false
    },
  },
  components: {
    BusComponent,
    Travelers,
    Tabs,
    Tab
  },
  // async created() {
  //   return this.getTravelers()
  // },
  data() {
    return {
      allPeople: []
    };
  },
  
  methods: {
      seatTaken (data) {
        let place = data.place
        let person = data.person
        let busId = data.bus
        for (let index = 0; index < this.allPeople.length; index++) {
          const p = this.allPeople[index];
          if(person.id === p.id ) {
            p.assigned = true
            p.place = place
            p.busId = busId
          }
        }
        
        //save the data
        tripApi
              .updateTravelDetails(this.tripId, person.id, "busPlace", place)
              .then(() => {
                this.showToast(`${this.$t("general.changesMade")}`);
              })
              .catch(e => {
                throw "Update failed";
              });


      },
      seatEmptied (data) {
        let person = data.person
        for (let index = 0; index < this.allPeople.length; index++) {
          const p = this.allPeople[index];
          if(person.id === p.id ) {
            p.assigned = false
            p.place = null
          }
        }
         tripApi
              .updateTravelDetails(this.tripId, person.id, "busPlace", 0)
              .then(() => {
                this.showToast(`${this.$t("general.changesMade")}`);
              })
              .catch(e => {
                throw "Update failed";
              });
      },
      placeClicked (data) {
        console.log("Data:" , JSON.stringify(data.person))
        let person = data.person
        // this.$router.push({name: 'add-traveller',query:{tripId: `${this.tripId}`, personId: `${person.personId}` }})
      
      },
      getTravelers() {
        this.isLoading = true;
        console.log("Trip ID:", this.tripId)
        tripApi.getAllParticipants(this.tripId)
          .then(participants => {
            let people = []
            participants.forEach(participant => {
              let p = {busId: "автобус-1", assigned: false}
              p.id = participant.id
              if(participant.busPlace != 0) {
                p.assigned = true
                p.place = participant.busPlace
              }
              if(participant.placeIsLocked != 0) {
                p.locked = true
              }
              p.name = participant.person.name
              p.personId = participant.person.id
              p.participantId = participant.id
              if(p.participantId == this.participantId) {
                p.active = true
              }
              //without drivers
              if(!participant.decline && participant.role != "driver") {
                if(p.active) {
                  people.unshift(p)
                } else {
                  people.push(p)
                }
              }
              
            });
            
            this.allPeople = people
            this.isLoading = false
          })
          .catch(() => {
            this.showToast("Something went wrong");
          });
    },
  },
}
</script>

<style lang="scss" scoped>
$greenColor: #4ae387;
$blackColor: #000000;
.container {
  display: flex;
  /* align-items: center; */
  /* justify-content: space-between; */

    // font-family: Helvetica, Arial, sans-serif;
    font-size: 12pt;
    line-height: 12pt;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  text-align: center;
  margin-top: 10px;
}

.tabs ul {
    list-style: none;
    padding: 0;
    margin: 0;
}

.tabs li {
  display: inline;
  border: solid;
  border-width: 1px 1px 0 1px;
  margin: 0 5px 0 0;
}
.vertical-list {
  margin-left: 20px;
}
.travelers {
  
}
.travelers-list {
  font-size: 16pt;
  color: $blackColor;
  font-weight: bolder;
}

</style>
